/* =========================================================================
   THIRD COAST — mobile coastline

   The drawn map is 300x940, so at phone width it renders as a ~190px sliver
   next to a ~900px list, aligned to nothing. Instead this takes the real
   shoreline path, stretches it to cover the coastal towns, and drops a dot on
   the line at each of their rows.

   Details that make it read correctly:
   - preserveAspectRatio="none" stretches the path vertically, which would turn
     circles into ovals, so dots are ellipses with rx/ry divided by the axis
     scales. They render as true circles.
   - Each dot's x is sampled off the path with getPointAtLength, so it sits on
     the shoreline rather than in a straight column.
   - The shoreline stops at the last coastal town. Everything below it is
     inland and has no place on the shore.
   ========================================================================= */
(function(){
  var SVG = 'http://www.w3.org/2000/svg';
  var mq = window.matchMedia('(max-width: 900px)');

  var VB = { x: 110, y: 20, w: 100, h: 880 };
  var WIDTH = 44;
  var DOT = 4;

  var SHORE = 'M205 20 Q202 40 198 55 Q192 95 196 130 Q200 180 180 225 ' +
              'Q162 275 180 320 Q196 370 166 415 Q148 455 160 490 ' +
              'Q170 535 152 575 Q136 630 142 680 Q148 760 126 830 ' +
              'Q116 872 120 900';
  var WATER = SHORE + ' L300 900 L300 20 Z';

  function xAtY(path, targetY){
    var len = path.getTotalLength(), lo = 0, hi = len, mid, pt;
    for(var i = 0; i < 24; i++){
      mid = (lo + hi) / 2;
      pt = path.getPointAtLength(mid);
      if(pt.y < targetY){ lo = mid; } else { hi = mid; }
    }
    return path.getPointAtLength((lo + hi) / 2).x;
  }

  function build(towns){
    var coastal = towns.querySelectorAll('.tc-town[data-coastal]');
    if(!coastal.length) return;

    var tBox = towns.getBoundingClientRect();
    var last = coastal[coastal.length - 1].getBoundingClientRect();

    // The shoreline runs from the top of the list to just past the last
    // coastal town, then stops. Inland towns sit below it.
    var h = Math.max(1, Math.round(last.bottom - tBox.top));

    var wrap = towns.querySelector('.tc-towns__coast');
    if(!wrap){
      wrap = document.createElementNS(SVG, 'svg');
      wrap.setAttribute('class', 'tc-towns__coast');
      wrap.setAttribute('aria-hidden', 'true');
      towns.insertBefore(wrap, towns.firstChild);
    }
    wrap.setAttribute('viewBox', VB.x + ' ' + VB.y + ' ' + VB.w + ' ' + VB.h);
    wrap.setAttribute('preserveAspectRatio', 'none');
    wrap.setAttribute('width', WIDTH);
    wrap.setAttribute('height', h);
    wrap.style.height = h + 'px';
    wrap.innerHTML = '';

    // Water fades out toward the list so there is no hard vertical edge.
    var defs = document.createElementNS(SVG, 'defs');
    var grad = document.createElementNS(SVG, 'linearGradient');
    grad.setAttribute('id', 'tcWaterFade');
    grad.setAttribute('gradientUnits', 'userSpaceOnUse');
    grad.setAttribute('x1', 120); grad.setAttribute('x2', 212);
    grad.setAttribute('y1', 0);   grad.setAttribute('y2', 0);
    [[0, .17], [0.55, .09], [1, 0]].forEach(function(s){
      var st = document.createElementNS(SVG, 'stop');
      st.setAttribute('offset', s[0]);
      st.setAttribute('stop-color', '#FBF6EF');
      st.setAttribute('stop-opacity', s[1]);
      grad.appendChild(st);
    });
    defs.appendChild(grad);
    wrap.appendChild(defs);

    var water = document.createElementNS(SVG, 'path');
    water.setAttribute('d', WATER);
    water.setAttribute('fill', 'url(#tcWaterFade)');
    wrap.appendChild(water);

    var shore = document.createElementNS(SVG, 'path');
    shore.setAttribute('class', 'tc-mapshore');
    shore.setAttribute('d', SHORE);
    wrap.appendChild(shore);

    var sx = WIDTH / VB.w, sy = h / VB.h;
    var rx = DOT / sx, ry = DOT / sy;

    coastal.forEach(function(row){
      var r = row.getBoundingClientRect();
      var yPx = r.top - tBox.top + r.height / 2;
      var vy = VB.y + (yPx / h) * VB.h;
      var vx = xAtY(shore, vy);

      var dot = document.createElementNS(SVG, 'ellipse');
      dot.setAttribute('cx', vx);
      dot.setAttribute('cy', vy);
      dot.setAttribute('rx', rx);
      dot.setAttribute('ry', ry);
      wrap.appendChild(dot);

      row.addEventListener('mouseenter', function(){ dot.classList.add('tc-on'); });
      row.addEventListener('mouseleave', function(){ dot.classList.remove('tc-on'); });
      row.addEventListener('focus', function(){ dot.classList.add('tc-on'); });
      row.addEventListener('blur', function(){ dot.classList.remove('tc-on'); });
    });

    // North and south markers, drawn as HTML so the stretch cannot skew them.
    ['n', 's'].forEach(function(dir){
      var el = towns.querySelector('.tc-towns__pole--' + dir);
      if(!el){
        el = document.createElement('span');
        el.className = 'tc-towns__pole tc-towns__pole--' + dir;
        el.setAttribute('aria-hidden', 'true');
        el.innerHTML =
          '<svg viewBox="0 0 12 16" focusable="false"><path d="M6 0 L11 8 L6 6 L1 8 Z"/></svg>' +
          '<em>' + (dir === 'n' ? 'N' : 'S') + '</em>';
        towns.appendChild(el);
      }
      el.style.top = dir === 'n' ? '0px' : (h + 'px');
    });
  }

  function refresh(){
    document.querySelectorAll('.tc-towns').forEach(function(towns){
      if(!mq.matches){
        var s = towns.querySelector('.tc-towns__coast');
        if(s) s.remove();
        towns.querySelectorAll('.tc-towns__pole').forEach(function(p){ p.remove(); });
        return;
      }
      build(towns);
    });
  }

  function init(){
    refresh();
    var t;
    window.addEventListener('resize', function(){
      clearTimeout(t);
      t = setTimeout(refresh, 200);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
